import styled from 'styled-components';

export const Flex1 = styled.div`
  flex: 1;
`;

export const WithSideBar = styled.div`
  height: 100vh;
  overflow: hidden;
  display: flex;
`;
export const WithSideBarContent = styled(Flex1)`
  display: flex;
  flex-direction: column;

  overflow: auto;
`;
export const AlertBoxContainer = styled.div`
  /* flex: 1;
  display: flex;
  flex-direction: column;
  position: relative;
  margin: 20px !important; */
  padding: ${({ theme }) => `${theme.spacing.x4} ${theme.spacing.x8}`};
  @media (max-width: ${({ theme }) => theme.media.xs}) {
    padding: ${({ theme }) => theme.spacing.x4};
  }
`;
export const WithSideBarMain = styled.main`
  flex: 1;
  max-height: calc(100vh - 64px);
  overflow: auto;
  display: flex;
  flex-direction: column;
  position: relative;
  padding: ${({ theme }) => `${theme.spacing.x4} ${theme.spacing.x8}`};
  @media (max-width: ${({ theme }) => theme.media.xs}) {
    padding: ${({ theme }) => theme.spacing.x4};
  }
`;
